import PropTypes from "prop-types";

const requireNativeComponent = require('react-native').requireNativeComponent ?? (() => null);
const ViewPropTypes = require('react-native').ViewPropTypes ?? {};

const portalOrigin = {
  name: "PortalOrigin",
  propTypes: {
    destination: PropTypes.string,
    ...ViewPropTypes
  }
};

const portalDestination = {
  name: "PortalDestination",
  propTypes: {
    name: PropTypes.string,
    ...ViewPropTypes
  }
};

export const PortalOrigin = requireNativeComponent(
  "RCTPortalOrigin",
  portalOrigin
);

export const PortalDestination = requireNativeComponent(
  "RCTPortalDestination",
  portalDestination
);
